module.exports = __webpack_public_path__ + "static/media/kid_avatar_09.448f9693.png";